import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { TopNav } from './TopNav';
import { Footer } from './Footer';

/** Document-flow layout: sticky top bar, page, footer. The window scrolls, not a pane. */
export function SiteLayout({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <div className="flex min-h-[100dvh] flex-col bg-paper font-sans text-ink">
      <TopNav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
